import * as React from 'react';

const GridViewSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <g fillRule="evenodd" clipRule="evenodd">
            <path d="M4 10h6V4H4v6zm1-5h4v4H5V5zM14 4v6h6V4h-6zm5 5h-4V5h4v4zM4 20h6v-6H4v6zm1-5h4v4H5v-4zM14 20h6v-6h-6v6zm1-5h4v4h-4v-4z" />
        </g>
    </svg>
);

GridViewSvg.displayName = 'GridViewSvg';
export default GridViewSvg;
